export const ERROR_TYPES = {
  PAGE: 1,
  COMPONENT: 2,
  ELEMENT: 3,
  DIALOG: 4,
};
